<template>
  <div class="d-flex justify-space-between align-top sm-gap">
    <div>
      {{ item.nom }} {{ vagueName }}
    </div>
    <div class="text-body font-weight-bold">
      <span v-if="item.current_price">{{ item.current_price }}€</span>
      <span v-else-if="is_team_price_included">Inclus</span>
      <span v-else>
        Gratuit
        <span v-if="item.cart?.prix_regulier"
          class="text-caption text-medium-emphasis text-decoration-line-through ml-1">
          {{ item.cart?.prix_regulier }}€
        </span>
      </span>
    </div>
  </div>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  props: ["item"],
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
    vagueName() {
      if (!this.item.vagues) return "";
      const vague = this.item.vagues.list.find((vague) => vague.selected);
      return vague ? " (Vague " + vague.nom + ")" : "";
    },
    is_team_price_included() {
      return this.item.cart?.is_team_price && !this.item.current_price;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/Cart.scss";
</style>